import React from 'react';
import { Tooth } from '../../../../graphql/graphql';
import DENTToothApical from './DENTToothApical';
import { ToothView } from '../../Enums/ToothView.enum';
import DENTToothFractures from '../Tooth/DENTToothFractures';
import { ToothViewData } from '../Tooth/teethData';
import DENTToothDiscoloration from '../Tooth/DENTToothDiscoloration';
import DENTToothAbrasion from '../Tooth/DENTToothAbrasion';
import DENTToothWearSurfaces from '../Tooth/DENTToothWearSurfaces';
import { TOOTH_WEAR_SURFACES_CONFIG } from '../../Helpers/toothWear/toothWearSurfaces.config';

interface Props {
	tooth: Tooth;
	toothViewData: ToothViewData;
	view: ToothView;
	width: number;
	height: number;
}

const DENTToothVisual = ({
	tooth,
	toothViewData,
	view,
	width,
	height,
}: Props) => {
	return (
		<>
			<DENTToothApical
				tooth={tooth}
				view={view}
				width={width}
				height={height}
			/>
			<DENTToothFractures data={tooth} toothViewData={toothViewData} />
			<DENTToothDiscoloration data={tooth} toothViewData={toothViewData} />
			<DENTToothAbrasion data={tooth} toothViewData={toothViewData} />
			{Object.values(TOOTH_WEAR_SURFACES_CONFIG).map(({ key, color }) => (
				<DENTToothWearSurfaces
					key={key}
					surfaces={tooth.pathology?.toothWear?.[key]?.surfaces}
					color={color}
					patternId={`toothWear-${key}-${tooth.number}`}
					toothViewData={toothViewData}
				/>
			))}
		</>
	);
};

export default DENTToothVisual;
